import axios from 'axios';
import { withFreshAuth } from './freshAuth';
import { ENDPOINTS } from '../config/endpoints';

const API_BASE_URL = ENDPOINTS.auth;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use(withFreshAuth);

export const adminService = {
  async getUsers(params = {}) {
    const response = await api.get('/admin/users', { params });
    return response.data;
  },

  async getUserLegal(email) {
    const response = await api.get(`/admin/users/${encodeURIComponent(email)}/legal`);
    return response.data?.items || [];
  },

  async updateUser(email, fields) {
    const response = await api.patch(`/admin/users/${encodeURIComponent(email)}`, fields);
    return response.data;
  },

  async createServiceToken(data) {
    const response = await api.post('/admin/service-tokens', data);
    return response.data;
  },

  async deleteUser(email) {
    const response = await api.delete(`/admin/users/${encodeURIComponent(email)}`);
    return response.data;
  },

  async getSettings() {
    const response = await api.get('/admin/settings');
    return response.data;
  },

  async updateSettings(settings) {
    const response = await api.patch('/admin/settings', settings);
    return response.data;
  },

  async getLlmModels() {
    const response = await api.get('/admin/llm-models');
    return response.data;
  },

  async getPrompts(type) {
    const params = type ? { prompt_type: type } : {};
    const response = await api.get('/admin/prompts', { params });
    return response.data;
  },

  async createPrompt(name, text) {
    const response = await api.post('/admin/prompts', { name, text });
    return response.data;
  },

  async updatePrompt(id, fields) {
    const response = await api.patch(`/admin/prompts/${id}`, fields);
    return response.data;
  },

  async deletePrompt(id) {
    const response = await api.delete(`/admin/prompts/${id}`);
    return response.data;
  },

  async getOffboardingState(status) {
    const response = await api.get('/admin/offboarding/state', { params: status ? { status } : {} });
    return response.data.items || [];
  },

  async dismissOffboarding(email) {
    const response = await api.post('/admin/offboarding/dismiss', { email });
    return response.data;
  },
};
